import type { TFunction } from 'i18next';
import type { ElementType } from 'react';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';

export type ProductCatalogCollectionNavTone = 'bestseller' | 'new' | 'sale';

export interface ProductCatalogCollectionContext {
  isSale: boolean
}

export interface ProductCatalogCollection {
  compareProducts?: (a: ViewProductStore, b: ViewProductStore) => number
  description: (t: TFunction) => string
  isActive?: (context: ProductCatalogCollectionContext) => boolean
  matchesProduct: (product: ViewProductStore) => boolean
  navIcon?: ElementType<{ className?: string }>
  navTone?: ProductCatalogCollectionNavTone
  slug: string
  title: (t: TFunction) => string
}

export function isProductCatalogCollectionActive(collection: ProductCatalogCollection, context: ProductCatalogCollectionContext) {
  return collection.isActive?.(context) ?? true;
}
